import React, { forwardRef, useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Slide from '@mui/material/Slide';
import * as icons from 'react-bootstrap-icons';
import CButton from 'Utils/Helpers/CButton';
import { HandleLoading } from 'Utils/Helpers/HandleLoading';
import { SetSystemTypes, SetUsersData } from 'Utils/Helpers/HandleApiData';
import { useSelector, useDispatch } from 'react-redux';
import { getTypes, updateTypeNameColor } from 'http/components/SettingService';
import { useSetState } from 'Utils/Helpers/Hooks';
import Inputer from 'Utils/Helpers/Inputer';
import { enqueueSnackbar } from 'notistack';

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function EditType({ id, title, color, staffs }) {
  const dispatch = useDispatch();
  const [show, setShow] = useState(false);
  const { total } = useSelector((state) => ({
    total: state.staff.total,
  }));
  const [controls, setControls] = useSetState ({
    name: {
      id: "name",
      type: 'text',
      placeholder: 'عنوان',
      value: '',
      icon: <icons.Type/>,
    },
    color: {
      id: "color",
      type: 'color',
      placeholder: 'رنگ',
      value: color,
      icon: <icons.PaletteFill/>,
    },
  });

  const onEnter = () => {
    setControls({name: { value: title } });
    setControls({color: { value: color } });
  }

  const setControlsValue = (name, value) => {
    setControls({ [name]: { value: value } });
  }

  const setShowDialog = () => {
    setShow(true);
  }

  const handleClose= () => {
    setShow(false);
  }

  const onFinish = async () => {
    dispatch(HandleLoading(true));
    const {name, color} = controls;
    if(name.value !== '' && color.value !== '') {
      const response = await updateTypeNameColor(id, name.value, color.value);
      if(response.status) {
        const response2 = await getTypes();
        if(response2.status) {
            await dispatch(SetUsersData(response2.data.users));
            await dispatch(SetSystemTypes(response2.data));
            setShow(false);
            enqueueSnackbar('نوع با موفقیت ویرایش شد', {variant: 'success'});
        } else {
          dispatch(HandleLoading(false));
        }
      } else {
        dispatch(HandleLoading(false));
      }
    } else {
      enqueueSnackbar('اطلاعات به درستی وارد نشده است', {variant: 'error'});
      dispatch(HandleLoading(false));
    }
  }

  return (
    <>
        <div className='edit' onClick={setShowDialog}>
          <icons.Pencil size={16}/>
        </div>
        {
          show &&
          <Dialog
              open={show}
              TransitionComponent={Transition}
              keepMounted
              fullWidth={true}
              maxWidth={'xs'}
              onClose={handleClose}
              TransitionProps={{onEnter: onEnter}}
              aria-describedby="alert-dialog-slide-type-edit"
          >
            <DialogTitle className='edit-mode'>
              {'ویرایش نوع'}
              <div className='close-btn' onClick={handleClose}>
                  <icons.X/>
              </div>
            </DialogTitle>
            <DialogContent>
              { 
                show &&
                <DialogContentText id="alert-dialog-slide-type-edit">
                  {
                    Object.keys(controls).map((key, index) => {
                      return (
                        <>
                          <small className='pe-1 mb-1'>{controls[key].placeholder}</small>
                          <Inputer
                            key={`inputer_${controls[key].id}`}
                            id={controls[key].id}
                            type={controls[key].type}
                            value={controls[key].value}
                            setValue={setControlsValue.bind(this)}
                            icon={controls[key].icon}
                            className={'mb-1'}
                          />
                        </>
                      )
                    })
                  }
                  <div className='d-flex flex-row px-2'>
                    <div>
                      <small className='ms-1'>
                        {staffs.length === 1 ? 'پزشک : ' : 'پزشکان : '}
                      </small>
                      {
                        staffs.map(id => {
                          return (
                            <small className='each-status'>
                              {total.find(i => i.id === id).name}
                            </small>
                          )
                        })
                      }
                    </div>
                    <small className='text-danger me-2'>
                      {'(غیر قابل تغییر)'}
                    </small>
                  </div>
                </DialogContentText>
              }
            </DialogContent>
            <DialogActions>
              <CButton
                text={'ویرایش نوع'}
                icon={<icons.Pencil/>}
                onClick={onFinish}
              />
            </DialogActions>
          </Dialog>
        }
      </>
  );
}
